import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ThumbUpIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fill={props.fill || "currentColor"}
                stroke="none"
                d="M 6.06005 1.704005 L 6.01685 1.884015 L 5.50235 3.983705 L 9.5856 3.983705 L 9.6013 4.79128 L 9.6013 5.523645 L 9.5974 5.68023 C 9.5974 5.68023 9.5542 5.778865 9.53845 5.825715 L 8.15995 8.88955 L 7.89025 9.40125 L 7.31815 9.40125 L -0 9.4 L -0 3.983705 L 2.254355 3.983705 L 5.4474 1 L 6.06005 1.704005 Z M 5.23265 2.128135 L 2.967845 4.252485 L 2.967845 4.26112 L 2.963915 4.26112 L 2.963915 8.744101 L 7.4543 8.744101 L 7.51585 8.6245 L 8.90485 5.56433 L 8.90485 4.63963 L 8.74515 4.63963 L 4.62392 4.63963 L 5.234 2.128135 L 5.23265 2.128135 Z M 2.26745 4.63963 L 0.69647 4.63963 L 0.69647 8.744101 L 2.26876 8.744101 L 2.26876 4.63963 L 2.26745 4.63963 Z"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ThumbUpIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fill={props.fill || "currentColor"}
                stroke="none"
                d="M 6.06005 1.704005 L 6.01685 1.884015 L 5.50235 3.983705 L 9.5856 3.983705 L 9.6013 4.79128 L 9.6013 5.523645 L 9.5974 5.68023 C 9.5974 5.68023 9.5542 5.778865 9.53845 5.825715 L 8.15995 8.88955 L 7.89025 9.40125 L 7.31815 9.40125 L -0 9.4 L -0 3.983705 L 2.254355 3.983705 L 5.4474 1 L 6.06005 1.704005 Z M 5.23265 2.128135 L 2.967845 4.252485 L 2.967845 4.26112 L 2.963915 4.26112 L 2.963915 8.744101 L 7.4543 8.744101 L 7.51585 8.6245 L 8.90485 5.56433 L 8.90485 4.63963 L 8.74515 4.63963 L 4.62392 4.63963 L 5.234 2.128135 L 5.23265 2.128135 Z M 2.26745 4.63963 L 0.69647 4.63963 L 0.69647 8.744101 L 2.26876 8.744101 L 2.26876 4.63963 L 2.26745 4.63963 Z"
            />
        </SvgIcon>
    );
};
